import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HTTPCONSTANTS, MerchantService } from '@odin/odin-core';
import { EMPTY, Observable } from 'rxjs';
import type { GatewaySettlementReport } from '../models/settlement-daily-report';

/**
 * Merchant reports served by Odin.Bff (/portal/reports), which passes back a
 * presigned URL from Mimir merchant reports. Reports are issued per Monek ID,
 * so the current MID is sent alongside the business unit.
 *
 * Backend route: POST /reports/gateway-settlement/{buid}/{mid} with body { date: "YYYY-MM-DD" }.
 */
@Injectable({ providedIn: 'root' })
export class MerchantReportsService {
  private readonly baseUrl = `${HTTPCONSTANTS.protocol}${HTTPCONSTANTS.baseAddress}/portal/reports`;

  constructor(private readonly http: HttpClient, private readonly merchantService: MerchantService) {}

  public getDailyMerchantReport(reportDate: Date): Observable<GatewaySettlementReport> {
    const buid = this.merchantService.getMerchantRef();
    const mid = this.merchantService.getCurrentMid();
    if (!buid || !mid?.monekId) return EMPTY;

    const url = `${this.baseUrl}/gateway-settlement/${buid}/${mid.monekId}`;
    return this.http.post<GatewaySettlementReport>(url, { date: this.toDateOnly(reportDate) });
  }

  // Plain YYYY-MM-DD from local date parts, so a local midnight never shifts a day via UTC.
  private toDateOnly(date: Date): string {
    const y = date.getFullYear();
    const m = `${date.getMonth() + 1}`.padStart(2, '0');
    const d = `${date.getDate()}`.padStart(2, '0');
    return `${y}-${m}-${d}`;
  }
}
